<template>
  <div>
    <div class="outerBox" :style="{ backgroundImage: 'url(' + imgPath + ')' }">
      <div class="register" @click="register">
        <div>立即注册</div>
        <img src="@/assets/image/jiantou.png" alt="" />
      </div>
    </div>
    <van-popup v-model="registerBox" position="bottom" round>
      <div class="popup_content">
        <input type="number" class="popup_input" placeholder="请输入手机号"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="mobile" />
        <div class="obtain">
          <div class="obtainOne">获取验证码</div>
          <div class="obtainTwo" @click="obtainClick"> {{ obtain == 0 ? "获取" : obtain }} </div>
          <van-count-down ref="countDown" :time="60 * 1000" format="ss" :autoStart="false" @change="onChange"
            v-show="false">
          </van-count-down>
        </div>
        <div class="verification">
          <van-password-input :value="passwordCode" :gutter="10" :focused="showKeyboard" @focus="showKeyboard = true" />
          <van-number-keyboard v-model="passwordCode" :show="showKeyboard" @blur="showKeyboard = false" />
        </div>
        <input type="text" class="popup_input" placeholder="请设置登录密码"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="password" />
        <input type="text" class="popup_input" placeholder="请确认登录密码"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="repassword" />
        <input type="text" class="popup_input" placeholder="填写邀请码（非必填）"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="invitecode" />
        <div class="register registerTwo" @click="logon" v-throttle>
          <div>注册并下载</div>
          <img src="@/assets/image/jiantou.png" alt="" />
        </div>
      </div>
    </van-popup>
    <download :isDown="isDown" @mongolia="downLoad"></download>

    <van-popup v-model="verifyPopup" position="bottom" round>
      <div class="popup_cont">
        <div class="popup_tip">图形验证</div>
        <div class="popup_two">
          <img :src="imgSrc" style="width: 100%;height: 100px;" @click="refreshCode">
        </div>
        <div class="popup_three">
          <input type="text" placeholder="请输入验证码" v-model="verifyCode" class="input">
        </div>
        <div class="popup_four" @click="obtainClick">确认</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  /**
   * Created by www.xingnuocn.com
   * @title：邀请技师
   *
   * @author: 刘嘉鑫
   * @version  V1.0
   * @datecreate: 2022-05-11 14:03
   */

  export default {
    data() {
      return {
        isDown: false, // 下载弹框
        imgPath: require("@/assets/image/yaoqingyonghu.jpg"),

        registerBox: false,

        obtain: "获取",
        time: 60,

        timeData: {},

        mobile: "", // 手机号

        passwordCode: "",
        showKeyboard: false,

        password: "", // 密码
        repassword: "", // 二次密码
        invitecode: "", // 邀请码

        user_id: "", // 邀请者id
        type: "", //

        isWeiXin: false,

        verifyPopup: false,
        verifyCode: "",
        imgSrc: ""
      };
    },
    mounted() {
      this.shop_id = this.$route.query.user_id; //用户id
      this.type = this.$route.query.type; // 邀请类型
      this.invitecode = this.$route.query.invitecode; //邀请码
      console.log(this.$client);

      if (this.$client.QQ != true && this.$client.WEIXIN != true) {
        if (this.$client.ANDROID == true) {
          try {
            window.location.href = "http://ttsm.xingnuo.vip/js_20220531.apk";
            // setTimeout(function () {
            //   window.location.href =
            //     "http://ttsm.xingnuo.vip/js_20220531.apk";
            // }, 500);
            console.log("安卓");
          } catch (e) { }
        }
        if (this.$client.IPHONE == true) {
          try {
            window.location.href =
              "https://apps.apple.com/cn/app/首摩到家技师/id1629633203";
            console.log("ios");
            return;
          } catch (e) { }
        }
      }

      document.title = "下载注册"; // 邀请技师
    },
    methods: {

      // 切换验证码
      refreshCode() {
        this.verifyCode = "";
        this.imgSrc = this.$root.baseUrlTwo + `/sms/getCaptcha?r=${Math.random()}&mobile=${this.mobile}`
      },

      /**
       * Created by www.xingnuocn.com
       * @title：注册
       *
       * @author: 刘嘉鑫
       * @version  V1.0
       * @datecreate: 2022-05-11 15:22
       */
      register() {
        this.registerBox = true;
      },

      /**
       * 倒计时
       * 刘嘉鑫
       * 2022-5-11
       */
      onChange(e) {
        this.timeData = e;
        this.obtain = e.seconds;
      },

      /**
       * 获取验证码
       * 刘嘉鑫
       * 2022-5-11
       */
      obtainClick() {
        let that = this;
        if (this.mobile == "") {
          this.$toast("请输入手机号");
          return;
        } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.$toast("手机号不正确");
          return;
        } if (this.verifyCode == '') {
          this.refreshCode()
          this.verifyPopup = true
          return
        } else {
          this.$axios({
            method: "post",
            headers: {
              "Content-Type": "application/json",
              // "Content-Type": "application/x-www-form-urlencoded",
            }, // 请求头
            url: `${this.$root.baseUrlTwo}/Sms/eaa19c86d   `, // /sms/sends
            data: {
              mobile: this.mobile,
              event: "register",
              type: 2, // 身份:1=商家,2=技师
              code: this.verifyCode
            },
          }).then((result) => {
            console.log("验证码", result);
            this.$toast(result.data.msg);
            if (result.data.code == 1) {
              that.$refs.countDown.start();
            }
          });
        }
      },

      /**
       * 注册并下载
       * 刘嘉鑫
       * 2022-5-11
       */
      logon() {
        let that = this;

        if (this.mobile == "") {
          this.$toast("请输入手机号");
          return;
        } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.$toast("手机号不正确");
          return;
        } else if (this.passwordCode == "") {
          this.$toast("请获取验证码");
          return;
        } else if (this.password == "") {
          this.$toast("请输入登录密码");
          return;
        } else if (this.repassword == "") {
          this.$toast("请再次输入密码");
          return;
        } else if (this.repassword != this.password) {
          this.$toast("两次密码不一致");
          return;
        } else {
          this.$axios({
            method: "post",
            headers: {
              "Content-Type": "application/json",
              // "Content-Type": "application/x-www-form-urlencoded",
            }, // 请求头
            url: `${this.$root.baseUrlTwo}/baselogin/register`,
            data: {
              mobile: this.mobile,
              password: this.password,
              repassword: this.repassword,
              code: this.passwordCode,
              invitecode: this.invitecode,
              shop_id: this.shop_id,
              type: 2,
            },
          }).then((result) => {
            console.log("注册", result);
            that.$toast(result.data.msg);
            if (result.data.code == 1 || result.data.code == 2) {
              that.registerBox = false;
              that.downLoad();
            }
          });
        }
      },

      /**
       * Created by www.xingnuocn.com
       * @title：下载
       *
       * @author: 刘嘉鑫
       * @version  V1.0
       * @datecreate: 2022-05-11 15:22
       */
      downLoad() {
        console.log("下载app");
        if (this.$client.QQ == true || this.$client.WEIXIN == true) {
          this.isDown = !this.isDown;
          return;
        } else {
          if (this.$client.ANDROID == true) {
            try {
              window.location.href = "http://ttsm.xingnuo.vip/js_20220531.apk";
              // setTimeout(function () {
              //   window.location.href =
              //     "http://qny.ttsmapp.xingnuo.vip/uploads/20220510/536da2afe80be46f30d5911c72ca15f9.apk";
              // }, 500);
              console.log("安卓");
            } catch (e) { }
          }
          if (this.$client.IPHONE == true) {
            try {
              window.location.href =
                "https://apps.apple.com/cn/app/首摩到家技师/id1629633203";
              console.log("ios");
              return;
            } catch (e) { }
          }
        }
      },

      /**
       * Created by www.xingnuocn.com
       * @title：关闭蒙层
       *
       * @author: 刘嘉鑫
       * @version  V1.0
       * @datecreate: 2021-06-25 16:10
       */
      mongolia() {
        this.isShow = false;
      },
    },
  };
</script>
<style>
  .van-password-input__security {
    height: 80px;
  }

  .van-password-input__item {
    width: 80px;
    height: 100px;
    border: 4px solid #e2e2e2;
    border-radius: 16px;
  }

  .van-key {
    height: 80px;
  }

  .van-toast {
    width: 30%;
    height: 6%;
    font-size: 28px;
  }
</style>
<style lang='scss' scoped>
  .outerBox {
    /* // background: url("~@/assets/image/yaoqingyonghu.png"); */
    width: 100%;
    height: 100%;
    position: fixed;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
  }

  .register {
    padding: 22px 130px 24px;
    background: linear-gradient(180deg, #fde394 0%, #ffb223 100%);
    box-shadow: 1px 14px 15px 0px rgba(1, 189, 156, 0.18);
    border-radius: 55px;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 61px;

    >div {
      font-size: 46px;
      font-family: FZZhengHeiS-EB-GB;
      font-weight: 400;
      color: #19a189;
      margin-right: 20px;
    }

    >img {
      width: 45px;
      height: 44px;
    }
  }

  .registerTwo {
    position: relative !important;
    margin-top: 100px;
    padding: 22px 0 24px;
    width: 100%;
    justify-content: center;
    background: linear-gradient(180deg, #fde394 0%, #ffb223 100%);
    box-shadow: 1px 14px 15px 0px rgba(255, 183, 46, 0.18);
  }

  .popup_content {
    padding: 80px 95px 50px;

    .popup_input {
      padding: 26px 16px;
      text-align: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #222222;
      border: 4px solid #e2e2e2;
      border-radius: 24px;
      width: 93%;
      margin-bottom: 40px;
    }

    .obtain {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .obtainOne {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
      }

      .obtainTwo {
        background: #00ba9a;
        border-radius: 12px;
        padding: 14px 32px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .verification {
      margin-bottom: 40px;
    }
  }

  .popup_cont {
    padding: 40px 40px 80px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .popup_tip {
      font-size: 34px;
      font-weight: bold;
      color: #222222;
      margin-bottom: 60px;
    }

    .popup_two {
      margin-bottom: 20px;
    }

    .popup_three {
      border: 4px solid #E2E2E2;
      border-radius: 16px;
      margin-bottom: 100px;
      width: 77%;

      .input {
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        color: #222222;
        border: none;
        padding: 36px 20px;
        border-radius: 16px;
        width: 92%;
      }

      .input::placeholder {
        color: #888888 !important;
      }
    }

    .popup_four {
      background: #00C3A1;
      border-radius: 16px;
      padding: 32px 100px;
      font-size: 34px;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
</style>
